<ng-template>
  <div @dropdownpanel (click)="closed.emit()"
    class="tw-relative tw-right-0 tw-mt-2 tw-min-w-56 tw-origin-top-right  tw-rounded-md tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none">
    <div class="tw-py-1">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>